import { useSyncExternalStore } from 'react';

export const REORDER_PREFERENCE_KEY = 'amposter:reorder-controls:v1';
const EVENT = 'amposter:reorder-controls-changed';
export const REORDER_MODES = ['arrows', 'drag', 'both'];
export function readReorderPreference() {
  try {
    const value = localStorage.getItem(REORDER_PREFERENCE_KEY);
    return REORDER_MODES.includes(value) ? value : 'both';
  } catch { return 'both'; }
}
export function setReorderPreference(value) {
  if (!REORDER_MODES.includes(value)) return;
  localStorage.setItem(REORDER_PREFERENCE_KEY, value);
  window.dispatchEvent(new Event(EVENT));
}
function subscribe(listener) {
  const storage = event => { if (!event.key || event.key === REORDER_PREFERENCE_KEY) listener(); };
  window.addEventListener(EVENT, listener);
  window.addEventListener('storage', storage);
  return () => { window.removeEventListener(EVENT, listener); window.removeEventListener('storage', storage); };
}
export function reorderHint(mode, language = 'ar') {
  if (language !== 'ar') return mode === 'arrows' ? 'Use the arrows to change the order.' : mode === 'drag' ? 'Hold the grip and drag to change the order.' : 'Drag by the grip, or use the arrows to change the order.';
  return mode === 'arrows' ? 'استخدم الأسهم لتغيير الترتيب.' : mode === 'drag' ? 'اضغط على مقبض السحب وحرّكه لتغيير الترتيب.' : 'اسحب من المقبض أو استخدم الأسهم لتغيير الترتيب.';
}
export default function useReorderPreference() {
  const mode = useSyncExternalStore(subscribe, readReorderPreference, () => 'both');
  return { mode, showArrows: mode !== 'drag', showDrag: mode !== 'arrows', setMode: setReorderPreference };
}
